"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactRedux = require("react-redux");

var _index = require("../../../utils/index");

var _editinfo = _interopRequireDefault(require("./editinfo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
//actions
// component

/* ========== ~~~~~~~~~~ EDIT INFO CTA : CONTAINER ~~~~~~~~~~ ========== */
// map state


var mapStateToProps = function mapStateToProps() {
  return {};
}; // map actions


var mapDispatchToProps = {
  setFormEditableState: _index.setFormEditableState,
  discardChanges: _index.discardChanges
};
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_editinfo.default);

exports.default = _default;